import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { FranchiseeService } from 'app/franchisee/franchisee.service';
import { openSnackbar } from 'app/store/actions/page.action';
import { ISelectItem } from 'app/store/models/select.model';
import { IReducers } from 'app/store/reducers';
import { ButtonDisablerService } from 'app/store/services/button-disabler.service';

@Component({
  selector: 'app-register-referral',
  templateUrl: './register-referral.component.html',
  styleUrls: ['./register-referral.component.scss']
})
export class RegisterReferralComponent implements OnInit {

  formGroup: FormGroup | null = null;

  confirmationToken: string | null = null;

  get accountTypeOptions(): ISelectItem[] {
    return [
      { label: 'Select account type', value: '' },
      { label: 'Checking', value: 'checking' },
      { label: 'Savings', value: 'savings' }
    ];
  }

  get entityTypeOptions(): ISelectItem[] {
    return [
      { label: 'LLC', value: 'LLC' },
      { label: 'Corporation', value: 'Corp' },
      { label: 'Individual', value: 'Individual' },
      { label: 'Partnership', value: 'Partnership' },
      { label: 'Sole Proprietorship', value: 'Sole Proprietorship' },
    ];
  }

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly router: Router,
    private readonly franchiseService: FranchiseeService,
    private readonly store$: Store<IReducers>,
    private readonly buttonDisablerService: ButtonDisablerService
  ) { }

  ngOnInit(): void {
    this.confirmationToken = this.activatedRoute.snapshot.queryParamMap.get('confirmation_token') || null;

    if(!this.confirmationToken) {
      this.router.navigate(['/']);
      return;
    }

    this.franchiseService.viewReferralPartnerByConfirmationToken(this.confirmationToken).subscribe(res => {
      const addressLine1 = res.address_line_1 || res.address || '';
      const addressLine2 = res.address_line_2 || '';

      this.formGroup = new FormGroup({
        name: new FormControl(res.name, [Validators.required]),
        contact_email: new FormControl(res.contact_email, [Validators.required, Validators.email]),
        contact_phone: new FormControl(res.contact_phone, [Validators.required]),
        company_name: new FormControl(res.company_name, [Validators.required]),
        entity_type: new FormControl(res.entity_type || '', [Validators.required]),
        signer_title: new FormControl(res.signer_title || '', [Validators.required]),
        address_line_1: new FormControl(addressLine1, [Validators.required]),
        address_line_2: new FormControl(addressLine2),
        ach_bank_name: new FormControl(res.ach_bank_name || ''),
        ach_bank_address: new FormControl(res.ach_bank_address || ''),
        ach_account_holder_name: new FormControl(res.ach_account_holder_name || ''),
        ach_account_number: new FormControl(res.ach_account_number || ''),
        ach_account_type: new FormControl(res.ach_account_type || '', [Validators.pattern('^(checking|savings)$')]),
        tax_id: new FormControl(res.tax_id || ''),
        ach_routing_number: new FormControl(res.ach_routing_number || '', [Validators.pattern('^[0-9]{9}$')]),
        confirmation_token: new FormControl(this.confirmationToken)
      });
    }, err => {
      this.router.navigate(['/']);
      this.store$.dispatch(openSnackbar({
        snackbarData: {
          data: {
            message: 'Invalid referral confirmation token.',
            type: 'error'
          },
          duration: 5000
        }
      }))
    });
  }


  onSubmit = () => {
    if(!this.formGroup || !this.formGroup.valid) {
      this.formGroup?.markAllAsTouched();
      this.buttonDisablerService.disableActive();
      return;
    }

    const data = this.formGroup.value;

    this.franchiseService.registerReferral(data).subscribe(() => {
      const { confirmation_token, ...summary } = data;

      this.router.navigate(['/register-referral/thank-you'], {
        state: { referralSummary: summary }
      });
    }, err => this.store$.dispatch(openSnackbar({
      snackbarData: {
        data: {
          message: err.error,
          type: 'error'
        },
        duration: 5000
      }
    })));
  }

}
